import { isSameDay as d } from "date-fns";
const p = (e, s, n, t) => {
  const r = e[s === "left" ? 0 : 1];
  return r && n.some((a) => d(a.$date, r)) ? r : n.some((o) => d(o.$date, t)) ? t : n.length > 0 ? n[0].$date : null;
}, h = (e) => {
  if (e.length === 0) return null;
  const s = e.filter((t) => t !== null).map((t) => ({
    element: t,
    date: parseInt((t.textContent || "").trim(), 10)
  })).filter(({ date: t }) => !isNaN(t) && t >= 1 && t <= 31);
  return s.length === 0 ? null : s.reduce(
    (t, c) => c.date > t.date ? c : t
  ).element;
}, f = (e) => e.querySelector(
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
), m = (e) => {
  const s = f(e);
  return s ? (s.focus(), !0) : !1;
}, x = (e, s) => {
  const n = e.getAttribute("data-testid") || "", t = n.includes("datepicker-select-month-") && n.endsWith("-trigger"), c = n.includes("datepicker-select-year-") && n.endsWith("-trigger");
  if (t || c) {
    const i = n.includes("-left-"), o = n.includes("-right-");
    if (i || o)
      return s;
  }
  const r = e.closest('[data-testid*="dropdown-component"]');
  if (r) {
    const i = r.getAttribute("data-testid") || "", o = i.includes("datepicker-select-month-"), a = i.includes("datepicker-select-year-"), l = i.includes("-left-"), u = i.includes("-right-");
    if ((l || u) && (o || a))
      return !0;
  }
  return !1;
}, b = (e) => {
  const s = e.closest("[data-testid]");
  return s ? (s.getAttribute("data-testid") || "").includes("datepicker-date-matrix-") : !1;
};
export {
  m as focusFirstElement,
  f as getFirstFocusableElement,
  p as getInitialFocusedDate,
  h as getLastDateRefOfMonth,
  b as isWithinDateMatrix,
  x as isWithinRangeDropdown
};
//# sourceMappingURL=index.es2484.js.map
